/** Pure catalog selectors. No mutation, requests, or database changes. */
export const CATALOG_PAGE_SIZES = [5, 10, 20, 30, 50];
export const catalogStatusLabels = { ACTIVE: 'Ativo', INACTIVE: 'Inativo', PLANNED: 'Planejado' };
export const catalogText = (value) => String(value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase('pt-BR');
export const catalogDate = (value) => {
  const text = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? text.split('-').reverse().join('/') : text || '—';
};
export const emptyCatalogFilters = () => ({ name: '', period: '', courseId: '', status: 'ACTIVE', from: '', to: '', notes: '', teacherIds: [], coordinator: '' });
export function catalogOptions(items = [], selected = []) {
  const known = new Map();
  items.forEach((item) => {
    const value = typeof item === 'object' ? item.value ?? item.id : item;
    const label = typeof item === 'object' ? item.label ?? item.name : item;
    if (value != null && value !== '') known.set(String(value), { value, label: String(label || value) });
  });
  selected.forEach((value) => { if (value != null && !known.has(String(value))) known.set(String(value), { value, label: `Professor ${value} (fora da lista atual)` }); });
  return [...known.values()];
}
export function toggleCatalogTeacher(values, value, checked) {
  const next = (Array.isArray(values) ? values : []).filter((id) => String(id) !== String(value));
  return checked ? [...next, value] : next;
}
export function courseNameFor(row, options, key = 'courseId') {
  return options.find((option) => String(option.value) === String(row[key]))?.label || row.courseName || row.groupName || (row[key] ? `Curso ${row[key]}` : '—');
}
export function teacherNamesFor(row, options) {
  return (Array.isArray(row.teacherIds) ? row.teacherIds : []).map((id) => options.find((option) => String(option.value) === String(id))?.label || `Professor ${id}`);
}
export function sortNewestCatalog(rows = []) {
  return [...rows].sort((a, b) => {
    const aTime = Date.parse(a.createdAt || ''); const bTime = Date.parse(b.createdAt || '');
    if (Number.isFinite(aTime) && Number.isFinite(bTime) && aTime !== bTime) return bTime - aTime;
    // IDs in both existing catalog APIs are increasing numeric primary keys.
    const aId = Number(a.id); const bId = Number(b.id);
    if (Number.isFinite(aId) && Number.isFinite(bId) && aId !== bId) return bId - aId;
    return String(b.id || '').localeCompare(String(a.id || ''), 'pt-BR', { numeric: true });
  });
}
export function filterCatalog(rows, filters = {}, courseKey = 'courseId') {
  const contains = (value, query) => !query || catalogText(value).includes(catalogText(query.trim()));
  return sortNewestCatalog(rows).filter((row) => {
    if (!contains(row.name, filters.name) || !contains(row.notes, filters.notes) || !contains(row.coordinator, filters.coordinator)) return false;
    if (filters.period && row.period !== filters.period) return false;
    if (filters.courseId && String(row[courseKey] || '') !== String(filters.courseId)) return false;
    if (filters.status && row.status !== filters.status) return false;
    const selected = filters.teacherIds || [];
    if (selected.length && !selected.some((id) => (row.teacherIds || []).some((saved) => String(saved) === String(id)))) return false;
    // Inclusive overlap with the requested period; missing end/start means open-ended.
    if (filters.from || filters.to) {
      const start = String(row.startDate || '').slice(0, 10); const end = String(row.endDate || '').slice(0, 10);
      if (!start && !end) return false;
      if (filters.from && end && end < filters.from) return false;
      if (filters.to && start && start > filters.to) return false;
      if (filters.from && filters.to && filters.from > filters.to) return false;
    }
    return true;
  });
}
export function paginateCatalog(rows, page = 1, pageSize = 10) {
  const size = CATALOG_PAGE_SIZES.includes(Number(pageSize)) ? Number(pageSize) : 10;
  const total = rows.length; const pages = Math.max(1, Math.ceil(total / size));
  const requested = Number.isFinite(Number(page)) ? Math.trunc(Number(page)) : 1;
  const current = Math.max(1, Math.min(requested || 1, pages));
  const offset = (current - 1) * size;
  return { rows: rows.slice(offset, offset + size), total, page: current, pages, size, start: total ? offset + 1 : 0, end: Math.min(offset + size, total) };
}
